<template>
    <section class="section section_type_main-side is_new-design" :class="$attrs.class">
        <slot name="head"></slot>
        <!--- Section type List --->
        <SectionList v-show="!isGuest && hasList" v-if="!isGuest && getAppUserId"/>

        <!--- Section type Basic --->
        <SectionBasic />
    </section>
</template>

<script>
    import SectionList from '@/components/SectionList.vue'
    import SectionBasic from '@/components/SectionBasic.vue'
    import {mapGetters} from "vuex";

    export default {
        name: "SectionMainside",
        mixins: [],
        data() {
            return {}
        },
        computed: {
            ...mapGetters([
                "isGuest",
                "getAppUserId",
            ]),
            hasList() {
                return !!this.routeMeta.list
            },
        },
        components: {
            SectionList, SectionBasic
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
.section {
    &.section_type_main-side {
        display: flex;
        width: 100%;
    }
}
</style>